import { apiFunction } from './apiHandler';

/* -------------------------------------------------------------------------- */
/*                               NEW AE Based APIs                            */
/* -------------------------------------------------------------------------- */
export const registerUser = async (payload) => {
  return await apiFunction('auth/register', 'post', payload, false, null);
};

// Valid
export const registerUserWithGoogle = async (payload) => {
  return await apiFunction('v1/auth/google-login', 'post', payload, false, null);
};

export const changePassword = async (payload) => {
  return await apiFunction('v1/auth/change-password', 'post', payload, true, null);
};

export const loginUser = async (payload) => {
  return await apiFunction('v1/auth/login', 'post', payload, false, null);
};


export const verifyOtp = async (payload) => {
  return await apiFunction(`v1/auth/verify-otp`, 'post', payload, false, null);
};

// END
//  ******************************
//  ******************************
//  ******************************
//  ******************************
//  ******************************
export const resendOTP = async (payload) => {
  return await apiFunction('auth/resend-otp', 'post', payload, false, null);
};

export const verifyEmail = async (payload) => {
  return await apiFunction('auth/verify-email', 'post', payload, false, null);
};

export const verifyLogin = async (payload) => {
  return await apiFunction('auth/verify-login', 'post', payload, false, null);
};

// product list
export const getAllProducts = async (payload) => {
  return await apiFunction('v1/product', 'get', payload, true, null);
};

// prodect detail API
export const getProductDetails = async (productId) => {
  return await apiFunction(`v1/product/${productId}`, 'get', {}, true, null);
};

export const getProductSearch = async (query) => {
  const params = new URLSearchParams();
  Object.keys(query).forEach((key) => {
    if (query[key]) {
      params.append(key, query[key]);
    }
  });

  const queryString = params.toString();
  return await apiFunction(
    `v1/product${queryString ? `?${queryString}` : ''}`,
    'get',
    {},
    true,
    null
  );
};

export const getCategories = async () => {
  return await apiFunction('v1/categories', 'get', {}, true, null);
};

// User Profile
export const getProfile = async () => {
  return await apiFunction('v1/user/me', 'get', {}, true, null);
};

export const WalletHold = async () => {
  return await apiFunction('v1/user/wallet', 'get', {}, true, null);
};

// Purchase Product
export const purchaseProduct = async (payload) => {
  return await apiFunction('v1/order', 'post', payload, true, null);
};

// User Order List
export const fetchUserOrder = async (payload) => {
  return await apiFunction(`v1/order`, 'get', payload, true, false)
};

// Voucher Details
export const fetchVoucherDetails = async (id) => {
  return await apiFunction(`v1/order/${id}`, 'get', {}, true, false);
};

// User Statement
export const fetchUserStatement = async (payload) => {
  return await apiFunction(`v1/wallet-transaction`, 'get', payload, true, false);
};

export const userAccountDelete = async (reason) => {
  const payload = { reason };

  return await apiFunction('/auth/delete-account', 'delete', payload, true, false);
};
/* -------------------------------------------------------------------------- */
/*                               END                                          */
/* -------------------------------------------------------------------------- */



// Login
export const getLogin = async (payload) => {
  return await apiFunction('user/login', 'post', payload, false, null);
};

// Sign up
export const signUp = async (payload) => {
  return await apiFunction('user/register', 'post', payload, false, null);
};


// Validate OTP -- user's otp validate --
export const verifyUserOtp = async (payload) => {
  return await apiFunction(`user/verifyOtp`, 'post', payload, true, null);
};

// Validate OTP -- user's otp validate
export const verifyForgotUserOtp = async (payload) => {
  return await apiFunction(`user/verifyOtpForgot`, 'post', payload, false, null);
};

// Get all Blogs
export const getBlogs = async () => {
  return await apiFunction('getblogs', 'get', {}, false, null);
};

// HomePage
export const getDashboardData = async () => {
  return await apiFunction('v1/dashboard', 'get', {}, true, null);
};

// All Categories
export const getAllCategory = async () => {
  return await apiFunction('categories', 'get', {}, true, null);
};

// Top Five Products Api --
export const getTopFiveProducts = async () => {
  return await apiFunction('topfive', 'get', {}, true, null);
};

// Best Seller Products Api --
export const getBestSellers = async () => {
  return await apiFunction('bestseller', 'get', {}, true, null);
};

// Featured Products Api --
export const getFeaturedProducts = async () => {
  return await apiFunction('featured', 'get', {}, true, null);
};


//Contact us
export const sendContactUs = async (payload) => {
  return await apiFunction('v1/customer-query', 'post', payload, false, null);
};

//Contact us
export const sendCompany = async (payload) => {
  return await apiFunction('/submit-corporate', 'post', payload, false, null);
};

//UserContact us
export const userComplainQuery = async (payload) => {
  return await apiFunction('send-query', 'post', payload, false, null);
};

//subscribe us
export const sendSubscribeUs = async (payload) => {
  return await apiFunction('subscribe', 'post', payload, false, null);
};

//validate token
export const validateToken = async () => {
  return await apiFunction('user/validate-token', 'post', {}, true, null);
};

//forgot password -- password change
export const forgotUserPassword = async (payload) => {
  return await apiFunction('user/forgot-password', 'post', payload, true, null);
};

//Balance
export const userBalance = async () => {
  return await apiFunction('user/balance', 'post', {}, true, null);
};



// find Voucher Details
export const fetchVoucherDetail = async (orderId, payload) => {
  return await apiFunction(`/user/card-list-new/${orderId}`, 'post', payload, true, false);
};

// find Voucher Details
export const razorpayVerifyPayment = async (orderId, payload) => {
  return await apiFunction(`/user/gift/verify-payment`, 'put', payload, true, false);
};



// fetch Notifications
export const fetchAllNotifications = async (payload) => {
  return await apiFunction(`user/notifications`, 'post', payload, true, false);
};

// all Sections
export const fetchMobileHomepage = async () => {
  return await apiFunction(`all-sections`, 'post', {}, true, false);
};

// upload user custom image
export const uploadWishPostImage = async (formData) => {
  return await apiFunction(`user/add-url-templete`, 'post', formData, true, 'multipart');
};
